import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["children", "InputLabelProps", "FormHelperTextProps", "label", "helperText", "id", "htmlFor", "variant"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FormControl, FormHelperText, InputLabel } from "components/mui";
import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FieldBase = function FieldBase(_ref) {
  var children = _ref.children,
    _ref$InputLabelProps = _ref.InputLabelProps,
    InputLabelProps = _ref$InputLabelProps === void 0 ? {} : _ref$InputLabelProps,
    _ref$FormHelperTextPr = _ref.FormHelperTextProps,
    FormHelperTextProps = _ref$FormHelperTextPr === void 0 ? {} : _ref$FormHelperTextPr,
    label = _ref.label,
    helperText = _ref.helperText,
    id = _ref.id,
    htmlFor = _ref.htmlFor,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "standard" : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(FormControl, _objectSpread(_objectSpread({
    variant: variant
  }, props), {}, {
    children: [label && /*#__PURE__*/_jsx(InputLabel, _objectSpread(_objectSpread({}, InputLabelProps), {}, {
      shrink: true,
      htmlFor: htmlFor,
      id: id,
      children: label
    })), children, helperText && /*#__PURE__*/_jsx(FormHelperText, _objectSpread(_objectSpread({}, FormHelperTextProps), {}, {
      children: helperText
    }))]
  }));
};
export default FieldBase;